import React, { useContext, useMemo, useState } from "react";

import { ElementState, Preview } from "@creatomate/preview";
import styled from "styled-components";

import { useDeepCompareEffect } from "app/hooks";
import { groupBy } from "app/utils";
import { CreatomateContext } from "../contexts/VideoStudioContext";
import Track from "./Track";

const Tracks = styled.div`
  width: 100%;
  height: 100%;
`;

interface TimelineTracksProps {
  preview: Preview;
}

const TimelineTracks: React.FC<TimelineTracksProps> = ({ preview }) => {
  const { data: { elements } } = useContext(CreatomateContext);
  const [tracks, setTracks] = useState<Map<any, ElementState[]>>(new Map());

  const filteredElements = useMemo(() => (
    elements.filter((element: ElementState) => (
      element.source.visible !== false
    ))
  ), [elements]);

  useDeepCompareEffect(() => {
    setTracks(groupBy(filteredElements, (element: ElementState) => element.track));
  }, [filteredElements]);

  return (
    <Tracks>
      {Array.from(tracks.entries()).reverse().map(([track, filteredElements]) => (
        <Track
          key={track}
          elements={filteredElements}
          preview={preview}
        />
      ))}
    </Tracks>
  );
};

export default TimelineTracks;
